/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Connectionstatus_Connected1Inputs */



/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Alarms_Connectionstatus_Connected1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_connectionstatus_connected1 = /** @type {((inputs?: Alarms_Connectionstatus_Connected1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Connectionstatus_Connected1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Connected")
	return /** @type {LocalizedString} */ ("Connecté")
});
export { alarms_connectionstatus_connected1 as "alarms_connectionStatus_connected" }